// Startseite der eingeschränkten Rollen (ADR 0316): setter-junior (Lida) startet in der Arbeitsliste,
// sobald die Registry (Admin → Ansichten) sie ihr freigibt, sonst im Stapel. Alle anderen
// eingeschränkten Rollen bleiben beim Stapel.
export const STAPEL_HOME = '/app/fraud0-leads';
export const ARBEITSLISTE_SEITE = 'fraud0_leads_arbeitsliste';

export interface AnsichtSeite { page: string; route: string }

export function scopedHome(role: string | undefined, viewPages: AnsichtSeite[]): string {
  if (role !== 'setter-junior') return STAPEL_HOME;
  const liste = viewPages.find((p) => p.page === ARBEITSLISTE_SEITE);
  return liste ? liste.route : STAPEL_HOME;
}
